import * as CommentsManager from '../../SDK/CommentsManager'

const comments = {
  state: {
    isAuth: -1,
    comments: [],
    mentionUsers: {
      contents: [],
      pageNum: 0,
      loading: false,
      hasMore: true
    },
    searchMentionUsers: {
      contents: [],
      pageNum: 0,
      loading: false,
      hasMore: true
    },
    comments_total: 0,
    commentsStatus: -1,
    hasMore: true,
    isRefresh: false,
    isLoading: false,
    page_num: 1
  },
  getters: {
    getComments: state => state.comments,
    getCommentsHasMore: state => state.hasMore,
    getCommentsLoading: state => state.isLoading,
    getMentionUsersList: state => state.mentionUsers.contents,
    getSearchMentionUsersList: state => state.searchMentionUsers.contents,
    getCommentsStatus: state => state.commentsStatus,
    getCommentsMentionHasMore: state => state.mentionUsers.hasMore,
    getCommentsMentionLoading: state => state.mentionUsers.loading,
    getCommentsSearchMentionHasMore: state => state.searchMentionUsers.hasMore,
    getCommentsSearchMentionLoading: state => state.searchMentionUsers.loading,
    getCurrentPageNum: state => state.page_num,
    getCurrentIsRefresh: state => state.isRefresh,
    getCurrentMentionNum: state => state.mentionUsers.pageNum,
    getMentionAuth: state => state.isAuth,
    getCurrentSearchMentionNum: state => state.searchMentionUsers.pageNum
  },
  mutations: {
    setComments (state, obj) {
      state.comments = state.comments.concat(obj)
      state.hasMore = obj.length === 10
      state.page_num += 1
      state.isRefresh = false
    },
    resetComments (state) {
      state.isRefresh = true
      state.comments = []
      state.hasMore = true
      state.page_num = 1
    },
    setMentionUsers (state, obj) {
      state.mentionUsers.contents = state.mentionUsers.contents.concat(obj.content)
      state.mentionUsers.hasMore = (obj.content.length === 12)
      state.mentionUsers.pageNum += 1
    },
    setSearchMentionUsers (state, obj) {
      state.searchMentionUsers.contents = state.searchMentionUsers.contents.concat(obj.content)
      state.searchMentionUsers.hasMore = (obj.content.length === 12)
      state.searchMentionUsers.pageNum += 1
    },
    setStatus (state, obj) {
      state.commentsStatus = obj
    },
    setCommentsMentionLoading (state, obj) {
      state.mentionUsers.loading = obj
    },
    setCommentsSearchMentionLoading (state, obj) {
      state.searchMentionUsers.loading = obj
    },
    resetMentionUsers (state) {
      state.mentionUsers.hasMore = true
      state.mentionUsers.contents = []
      state.mentionUsers.pageNum = 0
    },
    resetSearchMentionUsers (state) {
      state.searchMentionUsers.hasMore = true
      state.searchMentionUsers.contents = []
      state.searchMentionUsers.pageNum = 0
    },
    setAuth (state, obj) {
      state.isAuth = obj.retval
    },
    resetAuth (state) {
      state.isAuth = -1
    }
  },
  actions: {
    getComments ({commit}, obj) {
      var currentFile = obj.param.currentFile
      currentFile.page_num = obj.param.page_num
      CommentsManager.getComments(currentFile)
        .then(response => {
          if (response.comments) {
            commit('setStatus', 200)
            commit('setComments', response.comments)
          } else {
            commit('setStatus', 0)
            commit('setComments', [])
          }
        }, err => {
          commit('setStatus', 0)
          commit('setComments', [])
          console.log(err)
        })
    },
    deleteComments ({commit}, obj) {
      CommentsManager.deleteComment(obj.param)
        .then(response => {
          console.log(response)
          commit('setStatus', 202)
        })
    },
    getMentionUsers ({commit}, obj) {
      CommentsManager.listForPages(obj.param)
        .then(response => {
          commit('setMentionUsers', response)
          commit('setCommentsMentionLoading', false)
        })
    },
    getSearchMentionUsers ({commit}, obj) {
      CommentsManager.searchUser(obj.param)
        .then(response => {
          commit('setSearchMentionUsers', response)
          commit('setCommentsSearchMentionLoading', false)
        })
    },
    createComments ({commit}, obj) {
      CommentsManager.createComment(obj.param)
        .then(response => {
          commit('setStatus', 201)
          console.log(response)
        })
    },
    checkWhetherAuth ({commit}, obj) {
      CommentsManager.checkWhetherAuth(obj.param)
        .then(response => {
          commit('setAuth', response)
        })
    }
  }
}
export default comments



// WEBPACK FOOTER //
// ./src/store/modules/comments.js